import React from 'react'

export default class Logo extends React.Component {
  render(){
    return(
      <img alt='logo' width='300px' height='45px' src={require('../logo-ms.png')}/>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Logo.js